import { render, staticRenderFns } from "./LanguageToggle.vue?vue&type=template&id=391c56e8&scoped=true&"
import script from "./LanguageToggle.vue?vue&type=script&lang=js&"
export * from "./LanguageToggle.vue?vue&type=script&lang=js&"
import style0 from "./LanguageToggle.vue?vue&type=style&index=0&id=391c56e8&prod&lang=scss&scoped=true&"
import style1 from "./LanguageToggle.vue?vue&type=style&index=1&id=391c56e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391c56e8",
  null
  
)

export default component.exports